import styled, {css} from 'styled-components'
import {TableBodyCell} from '@/components/ui/table-atoms/TableAtoms'

export const StyledContactCell = styled(TableBodyCell)(
    () => css`
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        overflow: hidden;
        & p {
            max-width: 100%;
        }
    `
)
